import React, { useEffect, useState } from "react";
// import { Menu } from "antd"; // Not used
import {
  AppstoreOutlined,
  UserOutlined,
  // BarChartOutlined, // Not used
  SettingOutlined,
  CalendarOutlined,
  TeamOutlined,
  ShopOutlined,
  DollarOutlined,
  TrophyOutlined
} from "@ant-design/icons";
import { LogoType } from "../assets";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Sidebar = () => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState(location.pathname);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          setIsCollapsed(document.querySelector('.ant-layout-sider-collapsed') !== null);
        }
      });
    });

    const sider = document.querySelector('.ant-layout-sider');
    if (sider) {
      observer.observe(sider, { attributes: true });
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location]);

  const menuItems = [
    {
      key: "/dashboard",
      icon: <AppstoreOutlined />,
      label: "Tableau de bord",
    },
    {
      key: "/events",
      icon: <CalendarOutlined />,
      label: "Événements",
    },
    {
      key: "/organizers",
      icon: <TeamOutlined />,
      label: "Organisateurs",
    },
    {
      key: "/providers",
      icon: <ShopOutlined />,
      label: "Prestataires",
    },
    {
      key: "/sponsors",
      icon: <DollarOutlined />,
      label: "Sponsors",
    },
    {
      key: "/rewards",
      icon: <TrophyOutlined />,
      label: "Récompenses",
    },
    {
      key: "#",
      icon: <UserOutlined />,
      label: "Profil",
    },
    {
      key: "#",
      icon: <SettingOutlined />,
      label: "Paramètres",
    },
  ];

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Logo Section - Amélioré avec un meilleur espacement */}
      <div className="flex items-center justify-center h-20 border-b border-neutral-100 bg-gradient-to-r from-primary-50/50 to-white">
        <AnimatePresence mode="wait">
          {isCollapsed ? (
            <motion.div
              key="small-logo"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="p-3 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <img src="/logo192.svg" alt="Logo" className="w-8 h-8" />
            </motion.div>
          ) : (
            <motion.div
              key="full-logo"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="px-6 py-3"
            >
              <LogoType size="small" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Menu Section - Amélioré avec un meilleur espacement et animations */}
      <nav className="flex-1 px-4 py-8 overflow-y-auto scrollbar-thin scrollbar-thumb-neutral-200">
        <div className="space-y-3">
          {menuItems.map((item) => (
            <Link to={item.key} key={item.key}>
              <motion.div
                whileHover={{ scale: 1.02, x: 4 }}
                whileTap={{ scale: 0.98 }}
                className={`
                  flex items-center px-5 py-3.5 rounded-2xl cursor-pointer
                  transition-all duration-200 group relative
                  ${activeMenu === item.key 
                    ? 'bg-primary-50/80 text-primary-600 shadow-lg shadow-primary-100' 
                    : 'hover:bg-neutral-50 text-neutral-600'
                  }
                `}
              >
                <span className={`
                  text-xl group-hover:text-primary-500 transition-colors
                  ${activeMenu === item.key ? 'text-primary-500' : ''}
                `}>
                  {item.icon}
                </span>
                {!isCollapsed && (
                  <span className={`
                    ml-4 font-medium text-sm transition-colors
                    ${activeMenu === item.key ? 'text-primary-600' : 'text-neutral-700'}
                  `}>
                    {item.label}
                  </span>
                )}
                {activeMenu === item.key && (
                  <motion.div
                    layoutId="activeIndicator"
                    className="absolute right-4 w-2 h-2 rounded-full bg-primary-500"
                  />
                )}
              </motion.div>
            </Link>
          ))}
        </div>
      </nav>

      {/* Footer Section - Amélioré avec un meilleur design */}
      <div className="p-4 border-t border-neutral-100 bg-neutral-50/50">
        <motion.div 
          whileHover={{ scale: 1.02 }}
          className="flex items-center space-x-3 px-5 py-4 rounded-xl bg-white shadow-sm hover:shadow-md transition-all cursor-pointer"
        >
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-100">
            <span className="text-white text-sm font-medium">NS</span>
          </div>
          {!isCollapsed && (
            <div className="flex-1">
              <p className="text-sm font-semibold text-neutral-800">Nadia Sabra</p>
              <p className="text-xs text-neutral-500 mt-0.5">Administratrice</p>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Sidebar;
